import React from 'react';
import { Row, Col } from 'react-bootstrap';
import './commerce.css';

function CommerceHeader() {
  return (
    <div>
      <div className="content-main-header-commerces">
        <Row >
          <Col className="m-4">
            <h1 className="main-text slide-title">Busca los lugares que están <br/> cerca de ti</h1>
            
          </Col>
        </Row>
        <div className="conten-image-header">
          <Row className="m-4">
            {/* <Col xs={6} md={2} className="mb-2"><Image src="images/logo-claro-video.svg" className="logos-search" /></Col>
            <Col xs={6} md={2} className="mb-2"><Image src="images/logo-telcel.svg" className="logos-search" /></Col>
            <Col xs={6} md={2} className="mb-2"><Image src="images/logo-telmex.svg" className="logos-search" /></Col>
            <Col xs={6} md={2} className="mb-2"><Image src="images/logo-pase.svg" className="logos-search" /></Col>
            <Col xs={6} md={2} className="mb-2"><Image src="images/logo-gas-natural.svg" className="logos-search" /></Col>
            <Col xs={6} md={2} className="mb-2"><Image src="images/logo-cfe.svg" className="logos-search" /></Col> */}
          </Row>
        </div>
      </div>
    </div>
  );
  
}


export default CommerceHeader;